import React from 'react';

export interface CubiertosIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const CubiertosIcon: React.FC<CubiertosIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path 
        d="M14.2 23.4c.7 0 1.2-.4 1.2-.8v-11s1.7-1.9 1.7-4-.6-5.1-2.9-5.1-3.1 3.1-3.1 5 1.9 4.1 1.9 4.1v11.1c0 .4.5.8 1.1.8Zm8.4-20.7c-.5.4-1.8 1.4-2.3 2.6-.7 1.3-1 2.5-.6 4.5.3 1.2 1 2.1 1 2.1v10.7c0 .4.5.8 1.2.8s1.2-.4 1.2-.8V2.8c0-.2-.3-.3-.5-.1Zm-18 6.2v13.8c0 .4.5.8 1.2.8s1.2-.4 1.2-.8V8.9" 
        style={{ fill: 'none', stroke: '#fff', strokeMiterlimit: 10, strokeWidth: '2px' }}
      />
      <path 
        d="M8.7 2.8v4.8c0 .9-1.3 1.7-2.9 1.7s-2.9-.8-2.9-1.7V2.8m2.9 0v5.8" 
        style={{ strokeLinecap: 'round', fill: 'none', stroke: '#fff', strokeMiterlimit: 10, strokeWidth: '2px' }}
      />
    </svg>
  );
};

export default CubiertosIcon;
